<template>
  <div>
    <a-form-model ref="ruleform" :model="model" :rules="validatorRules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item prop="username" label="用户名" >
        <a-input v-model="model.username" size="large" type="text" autocomplete="false" placeholder="请输入用户名" />
      </a-form-model-item>

      <a-form-model-item prop="password" label="旧密码">
        <a-input v-model="model.password" size="large" type="text" autocomplete="false" placeholder="请输入旧密码"/>
      </a-form-model-item>

      <a-form-model-item prop="newpass" label="新密码">
        <a-input v-model="model.newpass" size="large" type="text" autocomplete="false" placeholder="新密码" ></a-input>
      </a-form-model-item>

      <a-form-model-item prop="password2" label="重复密码">
        <a-input v-model="model.password2" size="large" type="text" autocomplete="false" placeholder="重复密码" ></a-input>
      </a-form-model-item>

      <!-- <a-row :gutter="0">
        <a-col :span="18"> -->
          <a-form-model-item prop="inputCode" label="验证码">
            <a-input v-model="model.inputCode" size="large" type="text" placeholder="请输入验证码" style="width:280px">
              <a-icon slot="prefix" type="smile" :style="{ color: 'rgba(0,0,0,.25)' }"/>
            </a-input>
            <img v-if="requestCodeSuccess" style="margin-top: 2px;float:right" :src="randCodeImage" @click="handleChangeCheckCode" />
            <img v-else style="margin-top: 2px;float:right" src="../../../images/checkcode.png" @click="handleChangeCheckCode"/>
          </a-form-model-item>
        <!-- </a-col>
        <a-col :span="2" > -->

        <!-- </a-col>
      </a-row> -->


    </a-form-model>

  </div>
</template>
<script>
import http from '../../../js/axios'
export default {
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
      currdatetime: '',
      randCodeImage: '',
      requestCodeSuccess: false,
      model:{
        inputCode:''
      },
      validatorRules: {
        username: [
          { required: true,message:'请输入用户名！' },
          { validator: this.checkUsername }
        ],
        password: [
          { required: true, message: '请输入旧密码!'},
        ],
        newpass: [
          { required: true, message: '请输入新密码!' },
        ],
        password2:[
          { required: true, message: '请输入重复密码!'  },
          { validator: this.checkpass }
        ],
        inputCode: [{
          required: true, message: '请输入验证码!'
        }]
      },
      result:{}
    };
  },
  created() {
      this.handleChangeCheckCode();
    },
  methods: {
    handleChangeCheckCode(){
        this.currdatetime = new Date().getTime();
        this.model.inputCode = ''
        http.get(`/randomImage/${this.currdatetime}`
        ).then((res) => {
            this.randCodeImage = res.data.result
            this.requestCodeSuccess=true
        })
      },
    checkUsername(rule, value, callback) {
      this.queryByusername(value)
        if(!value){
          callback("请输入用户名")
        }else if(this.result==null){
          callback("用户不存在!")
        }else{
          callback()
        }
    },
    checkpass(rule, value, callback){
      if(!value){
          callback("请输入重复密码")
        }else if(value!=this.model.newpass){
          callback("两次密码不一致!")
        }else{
          callback()
        }
    },
    queryByusername(value){
      http.get('/queryByusername',{params:{username:value}}
      ).then((res) => {
            this.result = res.data.result;
      })
    },
    handleSubmit () {
        this.registerBtn = true;
        this.$refs.ruleform.validate(valid => {
          if (valid) {
            let values = this.model
            let model = {
              username: values.username,
              password: values.password,
              newpass:values.newpass,
              password2:values.password2,
              captcha: values.inputCode,
              checkKey: this.currdatetime,
            };
            http.updatePassword(model).then((res) => {
              if(res.data.success==true){
                this.$message.success("修改成功！")
              }else{
                this.$message.error(res.data.message)
              }
            })
          }
        })
      },
      clear(){
        this.model={}
      },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/login/moudles/EditPassword.vue